/* eslint-disable */
import { React, useRef, useState } from "react";
import Body from "./Body";
import * as yup from "yup";
import { Helmet } from "react-helmet";
// import ActivityMessaging from "../../../../store/ActivityMessaging.store";
const Activities = () => {
  const [donutChartData, setDonutChartData] = useState([
    {
      pollingCandidate: "Akram nawab",
      appearanceCount: 8,
      positionColor: "#14B8A6",
    },
    {
      pollingCandidate: "Darshan",
      appearanceCount: 4,
      positionColor: "#3B82F6",
    },
    {
      pollingCandidate: "Nishar khan",
      appearanceCount: 2,
      positionColor: "#6366F1",
    },
    {
      pollingCandidate: "Gyasuddin",
      appearanceCount: 2,
      positionColor: "#EC4899",
    },
    {
      pollingCandidate: "Ramij",
      appearanceCount: 1,
      positionColor: "#F59E0B",
    },
    {
      pollingCandidate: "Faruque",
      appearanceCount: 1,
      positionColor: "#FACC15",
    },
  ]);
  const [broadcastMessageInput, setBroadcastMessageInput] = useState({
    teachers: false,
    students: false,
  });
  const [votePollingFormModal, setVotePollingFormModal] = useState(false);
  const [createMeetingsModal, setCreateMeetingsModal] = useState(false);
  const [createEventsModal, setCreateEventsModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [promptModal, setPromptModal] = useState(false);
  const [promptModalStatus, setPromptModalStatus] = useState(false);
  const [viewMeetingDetailsModal, setViewMeetingDetailsModal] = useState(false);
  const [viewEventDetailsModal, setViewEventDetailsModal] = useState(false);
  const [openMessageHistory, setOpenMessageHistory] = useState(false);
  const [openMessageSentModal, setOpenMessageSentModal] = useState(false);

  const [meetingFormData, setMeetingFormData] = useState({});
  const [eventsFormData, setEventsFormData] = useState({});

  const broadCastMessageTeacherInput = useRef(null);
  const broadCastMessageStudentInput = useRef(null);

  console.log(promptModalStatus);

  const pollingFormValidation = yup.object().shape({
    purpose: yup
      .string("Required an text input")
      .required("This is a required field"),
    endTime: yup
      .string("Required an text input")
      .required("This is a required field"),
    endDate: yup
      .string("Required an text input")
      .required("This is a required field"),
    nomination1: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
    nomination2: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
    nomination3: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
    nomination4: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
    nomination5: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
    nomination6: yup
      .string("Required an text input")
      .notRequired("it is not a required field"),
  });
  const [eventData, setEventData] = useState([
    {
      _id: "khksnlsd5sdf5sf4s5s2v",
      eventName: "Annual Exam",
      subject: "Board meeting",
      time: "12:07 PM",
      eventDate: "2025/02/15-2025/02/15",
      eventMode: "Online",
    },
    {
      _id: "58sd1sd5sdf5sf4s5s2v",
      eventName: "Annual Exam",
      subject: "Board meeting",
      time: "12:07 PM",
      eventDate: "2025/02/15-2025/02/15",
      eventMode: "Offline",
    },
    {
      _id: "58sd1sd5sd76ds75sf4s5s2v",
      eventName: "Annual Exam",
      subject: "Board meeting",
      time: "12:07 PM",
      eventDate: "2025/02/15-2025/02/15",
      eventMode: "Online",
    },
  ]);
  const [meetingData, setMeetingData] = useState([
    {
      _id: "khksnlsd5sdf5sf4s5s2v",
      subject: "Annual Exam",
      meetingDate: "2025/02/15",
      color: "orange",
      meetingMode: "Online",
      designation: "Sk Sarfaraj",
      whom: "Board Members",
      time: "12:30 PM",
    },
    {
      _id: "58sd1sd5sdf5sf4s5s2v",
      subject: "Guardian meeting",
      meetingDate: "2025/02/02-2025/03/25",
      color: "green",
      meetingMode: "Offline",
      designation: "Mizanur Rahaman",
      whom: "Board Members",
      time: "12:30 PM",
    },
    {
      _id: "5485s1sd5sd76ds75sf4s5s2v",
      subject: "Sports",
      meetingDate: "2025/02/02-2025/03/25",
      color: "green",
      meetingMode: "Offline",
      designation: "Md Rejuwanul Karim",
      whom: "Board Members",
      time: "12:30 PM",
    },
    {
      _id: "58sd1s68576ds75sf4s5s2v",
      subject: "Teachers Meeting",
      meetingDate: "2025/02/02-2025/03/25",
      color: "yellow",
      meetingMode: "online",
      designation: "Sk Hiraj",
      whom: "Board Members",
      time: "12:30 PM",
    },
  ]);
  const [eventModalData, setEventModalData] = useState(null);
  const [meetingModalData, setMeetingModalData] = useState(null);

  const handelEventModalFilter = (_id) => {
    const filter =
      eventData &&
      eventData.filter((data) => data._id.toString() == _id.toString());
    setEventModalData(filter);
  };
  const handelMeetingModalFilter = (_id) => {
    const filter =
      meetingData &&
      meetingData.filter((data) => data._id.toString() == _id.toString());
    setMeetingModalData(filter);
  };

  const _this = {
    donutChartData,
    broadcastMessageInput,
    setBroadcastMessageInput,
    broadCastMessageTeacherInput,
    broadCastMessageStudentInput,
    votePollingFormModal,
    setVotePollingFormModal,
    pollingFormValidation,

    setCreateMeetingsModal,
    createMeetingsModal,
    setMeetingFormData,
    meetingFormData,
    createEventsModal,
    setCreateEventsModal,
    eventsFormData,
    setEventsFormData,
    viewMeetingDetailsModal,
    setViewMeetingDetailsModal,
    viewEventDetailsModal,
    setViewEventDetailsModal,
    eventData,
    setEventData,
    eventModalData,
    setEventModalData,
    handelEventModalFilter,
    handelMeetingModalFilter,
    meetingData,
    setMeetingData,
    meetingModalData,
    alertModal,
    setAlertModal,
    promptModal,
    setPromptModal,
    promptModalStatus,
    setPromptModalStatus,
    openMessageHistory,
    setOpenMessageHistory,
    openMessageSentModal,
    setOpenMessageSentModal,
  };

  return <Body {..._this} />;
};

export default Activities;
